import loadCSSVariablesPonyfill from './cssVariables';

const initialize = function() {
  loadCSSVariablesPonyfill();
};
export default initialize;
